import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'web/users';

export default {
  async search(queryParams) {
    const url = mountUrl(`/${BASE_PATH}/organization`, queryParams);
    return api.get(url);
  },
  async inactivate(userId) {
    const url = mountUrl(`/${BASE_PATH}/${userId}/inactivate`);
    return api.delete(url);
  },
  checkUserCanAccessSystem() {
    const url = mountUrl(`/${BASE_PATH}/can-access-system`);
    return api.get(url);
  }
};
